<template lang="">
  <div>
    <div>
      <Header
        title="Agendamentos"
        subtitle="Agendamentos de SMS"
      ></Header>
      <template>
        <v-tabs
          v-model="tab"
          color='black'
          class="d-flex justify-start"
        >
          <v-tab href="#schedule" name="schedule" class="mb-2">
            <img width="20" src="../../../../static/images/calendar.svg"/>
            <span class="pl-3 ff">Agendamentos</span>
          </v-tab>
          <v-tab href="#logs" name="logs" class="mb-2">
            <img width="20" src="../../../../static/images/folder.svg"/>
            <span class="pl-3 ff">Logs</span>
          </v-tab>
        </v-tabs>
      </template>
      <hr>
      <div v-if="tab === 'schedule'">
        <Schedule v-on:close="drawer = false"/>
        <!-- <DuplicateForm /> -->
      </div>
      <div v-if="tab === 'logs'">
        <Logs />
      </div>
    </div>


  </div>
</template>
<script>
// Components
import Header from '@/components/Header.vue'
import Logs from '@/components/Contents/ScheduleWeb/Logs'
import Schedule from '@/components/Contents/ScheduleWeb/Schedule'
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  components: {
    Header,
    Logs,
    Schedule,
    // DuplicateForm
  },
  methods: {
    ...mapMutations("PushWebLogs", {
      setRequestUri: "SET_REQUEST_URI",
    }),
    changeEndpoint() {
       this.setRequestUri('/api/getMessgit reset --hard ages')
    }
  },
  async created() {
    await this.changeEndpoint();
  },

  data () {
    return {
      tab: 'schedule',
      drawer: true
    }
  }
}
</script>
<style lang="" scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/Contents/ScheduleWeb/SchedulingWeb.vue